import React from "react";
import PropTypes from "prop-types";
import PlanNameItem from "./PlanNameItem";
import { PromotionStyle } from "./PlanNameStyle";
import FilterItems from "../filterItems/FilterItems";
const PlanName = (props) => {
  return (
    <>
      {" "}
      <div className="customFilter d-none d-lg-block">
        {" "}
        {props?.planName&& props?.planName.length >0 && (<p className="filter-heading">Plan name</p>)}{" "}        {props?.planName?.map((item, index) => (
          <PlanNameItem
            key={`plan-name-${item.id}-${index}`}
            planname={item}
            filteredPlanName={
              props.filteredPlanName ? props.filteredPlanName : []
            }
            plannameClickHandler={(flag) =>
              props.handlePlannameSelect(flag, item)
            }
          />
        ))}{" "}
      </div>{" "}
      <FilterItems heading="Plan name" handleClick={props.planNames}
      id={props?.displayPlanName == true && props?.filteredPlanName?.length ? `filtered_brands_${props?.filteredPlanName}` : null}
      renderFun={ props?.filteredPlanName?.map(brand => brand.label).join(", ")}
      />{" "}
      <style jsx>{PromotionStyle}</style>{" "}
    </>
  );
};
PlanName.propTypes = {
  promotions: PropTypes.array,
  promo: PropTypes.func,
  filteredPromotions: PropTypes.string,
  handlePromotionSelect: PropTypes.func,
  planName: PropTypes.array,
  filteredPlanName: PropTypes.array,
  handlePlannameSelect: PropTypes.func,
  planNames: PropTypes.any,
  displayPlanName: PropTypes.bool,
};
export default PlanName;
